var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B2b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 6.8,
    y: 8.57142857,
    width: 3.4,
    height: 4.28571429,
    rx: 1.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B2b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.141587409,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-14",
    stroke: "#80959D",
    points: "15.8666667 9.64285714 15.8666667 15 1.13333333 15 1.13333333 9.64285714 1.13333333 9.64285714"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    stroke: "#80959D",
    x: 5.03333333,
    y: 0.5,
    width: 6.93333333,
    height: 2.21428571,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,2.64285714 C0.76862915,2.64285714 0.5,2.91148629 0.5,3.24285714 L0.5,8.78575132 C0.5,9.06062991 0.686789418,9.30035336 0.953328545,9.3675481 L8.35332854,11.2330943 C8.44960339,11.2573653 8.55039661,11.2573653 8.64667146,11.2330943 L16.0466715,9.3675481 C16.3132106,9.30035336 16.5,9.06062991 16.5,8.78575132 L16.5,3.24285714 C16.5,2.91148629 16.2313708,2.64285714 15.9,2.64285714 L1.1,2.64285714 Z",
    id: "Rectangle-12",
    stroke: "#80959D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-18"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#80959D",
    strokeWidth: 1,
    x: 7.3,
    y: 9.07142857,
    width: 2.4,
    height: 3.28571429,
    rx: 1.1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2B);
export default __webpack_public_path__ + "static/media/b2b.1f86bb773ff1e2c015723f3a04405fa7.svg";
export { ForwardRef as ReactComponent };